import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';



import {Column, GridOption, AngularGridInstance, Formatters} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Subscription} from 'rxjs';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
//import {CdkDragDrop, moveItemInArray} from '@angular/dr';

@Component({
  selector: 'app-report-configurator',
  templateUrl: './report-configurator.component.html',
  styleUrls: ['./report-configurator.component.css']
})
export class ReportConfiguratorComponent implements OnInit {

  dataLoaded: boolean;
  angularGrid: AngularGridInstance;
  gridObj: any;
  private notifier: NotifierService;
  respObject: any;
  private clientId: number;
  displayed = true;
  columnObjArray = [];
  selectedColums: any;
  templateName: string;

  reportTableName: string;

  selectedFilterValue: string;
  selectedFilterType: string;
  fromDate: string;
  toDate: string;
  selectedFilterObjArray = [];
  selectedFilter: string;
  slectedColumnID: number;

  reportTableListArray = [];
  selectedReportTableId: number;
  reportTypeObjArray = [];
  reportGraphTypeObjArray = [];
  graphReport: boolean;
  reportTypeSelected: string;
  reportGraphTypeSelected: string;

  timeStampOperatorList = [];
  operatorSelected: string;

  varcharOperatorList = [];
  
  viewFromDate: boolean;
  viewToDate: boolean;

  errorMessage: string;
  selectedVarcharOperator: string;
  filterValue: string;

  gridOptions: GridOption;
  columnDefinitions: Column[];
  selectedColumnObjArray = [];
  isError = false;
  @ViewChild('content') private content;
  private dialogRef: MatDialogRef<any, any>;

  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
      private modalService: NgbModal, notifier: NotifierService, private dialog: MatDialog) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
          // console.log(item);
          switch (item.type) {
              case 'change':
                  if (!this.messageService.edit) {
                      this.notifier.notify('error', 'You do not have edit permission');
                  } else {
                      if (confirm('Are you sure?')) {
                        console.log(JSON.stringify(item));
                      }
                  }
                  break;
              case 'delete':
                  // console.log('deleted');
                  if (!this.messageService.del) {
                      this.notifier.notify('error', 'You do not have delete permission');
                  } else {
                      if (confirm('Are you sure?')) {
                        console.log(JSON.stringify(item));
                      }
                  }
                  break;
          }
      });
   
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    console.log('grid initiate');
    this.angularGrid = angularGrid;
    this.gridObj = angularGrid && angularGrid.slickGrid || {};
  }
 

  toggleViews() {
    this.displayed = !this.displayed;
  }

  ngOnInit() {
    this.dataLoaded = true;
    this._rest.getUserdetails(this.messageService.getUserId()).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.clientId = this.respObject.details[0].clientId; 
        this.onPageLoad(); 
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });

    const columnDefinitions = [
          {
              id: 'column_name', name: 'Column Name', field: 'column_name', sortable: false, filterable: false
          },
          {
              id: 'report_field_name', name: 'Report Field Name', field: 'report_field_name', sortable: false, filterable: false, editable: true, editor: {
                model: CustomInputEditor,
            }
          },
          {
            id: 'filter', name: 'Report Filter', field: 'filter', sortable: false, filterable: false
          }
      ];

    this.gridOptions = {
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableFiltering: true,
      editable: true,
      rowSelectionOptions: {
        selectActiveRow: false
      },
      enableCheckboxSelector: false,
      enableRowSelection: true,
      enableHeaderMenu: false,
      enableGridMenu : false,
    };
    this.columnDefinitions = columnDefinitions;
  }

  onPageLoad() {
    this.reportTableName = '';
    this.selectedColumnObjArray = [];
    this.templateName = "";
    this.graphReport = false;
    this.reportTypeObjArray = [{type:"0", view:"Select Report Type"},{type:"table", view:"Grid View"}];
    // this.reportTypeObjArray = [{type:"0", view:"Select Report Type"},{type:"table", view:"Grid View"},{type:"graph", view:"Graphical View"}];
    this.reportTypeSelected = "0";
    this.reportGraphTypeObjArray = [{type:"0", view:"Select Graph Type"},{type:"barchart", view:"Bar Chart"},{type:"piechart", view:"Pie Chart"}]
    this.reportGraphTypeSelected = "0";
    

    this.getStagingTableList();
  }

  getStagingTableList(){
    this._rest.getStagingTableList(this.clientId).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        this.reportTableListArray = this.respObject.details;
        this.selectedReportTableId = 0;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  onReportTableChange(value: any){
    this.reportTableName = this.reportTableListArray[value].view;
    this.getColumListByTableName(this.reportTableName);
  }

  onchangeVarcharOperator(value: any){
    
  }

  onReportTypeChange(value: any){
    console.log(this.reportTypeSelected);
    if(this.reportTypeSelected === "graph"){
      this.graphReport = true;
    }
    else{
      this.graphReport = false;
    }
  }

  onReportGraphTypeChange(value: any){
    console.log(value);
    console.log(this.reportGraphTypeSelected);
  }

  onFilterChange(event){
    console.log(event);
  }

  openModal(content) {
      if (!this.messageService.add) {
          this.notifier.notify('error', 'You do not have add permission');
      } else {
          
          this.errorMessage = "";
          this.operatorSelected = "0";
          this.viewFromDate = true;
          this.viewToDate = false;
          this.selectedFilter = "Select Filter";
          this.selectedVarcharOperator = "0";
          this.dialogRef = this.dialog.open(this.content, {
              width: '800px'
          });
      }
  }

  onOperatorChange(value: any){
    console.log(value);
    console.log(this.operatorSelected);
    if(this.operatorSelected === "between"){
      this.viewToDate = true;
    }else{
      this.viewToDate = false;
    }
  }

  onCellChanged(e, args) {
    // console.log(JSON.stringify(args));
    args.item.type = 'change';
    this.messageService.setCellChangeData(args.item);
  }

  onCellClicked(e, args) {
    this.dataLoaded = false;
    this.timeStampOperatorList = [{operator:"0", view: "Select Operator"},
                            {operator:">", view: "Greater than (>)"},
                            {operator:">=", view: "Greater than or equal (>=)"},
                            {operator:"<", view: "Less than (<)"},
                            {operator:"<=", view: "Less than or equal (<=)"},
                            {operator:"between", view: "Between and"}
                          ];

    this.varcharOperatorList = [{operator:"0", view: "Select Operator"},
                          {operator:"a%", view: "Like (Start with)"},
                          {operator:"%a", view: "Like (End with)"},
                          {operator:"%a%", view: "Like (Any Position)"},
                          {operator:"=", view: "Equal (=)"}
                        ];

    const selectedRow = this.angularGrid.gridService.getColumnFromEventArguments(args);
    //console.log(selectedRow);
    //console.log(selectedRow.cell);
    if(selectedRow.cell === 2){
      //alert("Add Filter");
      console.log(selectedRow.dataContext.filter);
      this.selectedFilterType = selectedRow.dataContext.column_type.toUpperCase();
      this.slectedColumnID = selectedRow.dataContext.id;
      if(this.selectedFilterType === 'TIMESTAMP'){
        this.fromDate  = '';
        this.toDate = '';
        this.selectedFilterObjArray = [];
        console.log("Get Min - Max Date");
        this.openModal(this.content);
      }
      else if(this.selectedFilterType === 'VARCHAR' || this.selectedFilterType === 'TEXT'){
        console.log("Get Unique Value");
        this._rest.getUniqueValueByField(this.clientId,selectedRow.dataContext.column_name,this.reportTableName).subscribe((res1) => {
          this.respObject = res1;
          if (this.respObject.success) {
            this.selectedFilterObjArray = this.respObject.details;
            this.selectedFilterObjArray.unshift({id: 0, uniqueField: 'Select Filter'});
            this.selectedFilter = "Select Filter";
            this.varcharOperatorList.push({operator:"dropdown", view: "Dropdown Select"});
            this.openModal(this.content);
            this.dataLoaded = true;
          } else {
            //alert("Field Not Filterable");
            //this.varcharOperatorList.pop();
            this.selectedFilterObjArray = [];
            this.openModal(this.content);
            this.dataLoaded = true;
          }
        }, (err) => {
          this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
      }
      else if(this.selectedFilterType === 'INT'){
        console.log("Get Min - Max Value / Enter Min - Max Value");
        //this.openModal(this.content);
        alert("Field Not Filterable");
      }
      else{
        alert("Field Not Filterable");
      }
    }
    this.dataLoaded = true;
  }

  saveReportFilter(){
    if(this.selectedFilterType === 'TIMESTAMP'){
      var dateFilter = "";
      const fdate = this.messageService.ticketConverter(this.fromDate, 1);
      const tdate = this.messageService.ticketConverter(this.toDate, 1);

      if(this.operatorSelected === "0"){
        this.notifier.notify('error', "Please select an operator");
        return;
      }else if(this.operatorSelected === "between"){
        if(fdate === ""){
          this.notifier.notify('error', "Please select from date");
          return;
        }
        else if(tdate === ""){
          this.notifier.notify('error', "Please select to date");
          return;
        }
        dateFilter = fdate +","+tdate;
      }else{
        if(fdate === ""){
          this.notifier.notify('error', "Please select date");
          return;
        }
        dateFilter = fdate;
      }
      
      console.log("Date Filter "+ dateFilter);
      var objIndex = this.selectedColumnObjArray.findIndex((obj => obj.id == this.slectedColumnID));
      this.selectedColumnObjArray[objIndex].filter = dateFilter;
      this.selectedColumnObjArray[objIndex].operator = this.operatorSelected;
      
      console.log(this.selectedColumnObjArray); 
      this.angularGrid.gridService.updateDataGridItem(this.selectedColumnObjArray[objIndex]);
      this.close();
    }
    else if(this.selectedFilterType === 'VARCHAR' || this.selectedFilterType === 'TEXT'){
      var newFilterValue = "";
      if(this.selectedVarcharOperator === "0"){
        this.notifier.notify('error', "Please select an operator");
        return;
      }else if(this.selectedVarcharOperator === "dropdown"){
        console.log("Filter Seleted - " + this.selectedFilter);
        if(this.selectedFilter === "Select Filter"){
          this.notifier.notify('error', "Please select a Filter");
          return;
        }
        newFilterValue = this.selectedFilter;
        console.log("Filter Seleted newFilterValue - " + this.selectedFilter);
      }
      else{
        if(this.filterValue === ""){
          this.notifier.notify('error', "Please enter a Filter");
          return;
        }
        newFilterValue = this.filterValue;
      }

      var objIndex = this.selectedColumnObjArray.findIndex((obj => obj.id == this.slectedColumnID));
      this.selectedColumnObjArray[objIndex].filter = newFilterValue;
      this.selectedColumnObjArray[objIndex].operator = this.selectedVarcharOperator;
      
      console.log(this.selectedColumnObjArray); 
      this.angularGrid.gridService.updateDataGridItem(this.selectedColumnObjArray[objIndex]);
      this.close();


    }
    
  }

  getColumListByTableName(tableName){
    this.dataLoaded = false;
    this._rest.getColumListByTableName(this.clientId, tableName).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        this.dataLoaded = true;
        this.respObject.details.forEach((item, i) => {
          item.id = i + 1;
          item.report_field_name = item.column_name;
          item.sequence  = i + 1;
          item.filter  = "";
          item.operator  = "";
        });
        this.columnObjArray = this.respObject.details;
      } else {
        this.dataLoaded = true;
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.dataLoaded = true;
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  onColumsChange(event){
    console.log('on ng model change', event);
    console.log('Selected - ', this.selectedColums);
    
    this.selectedColumnObjArray = event.slice();
    
  }

  getValue(event){
      console.log(event);
  }

  saveTemplate(){
    if( this.templateName === ""){
      this.notifier.notify('error', "Please enter template name");
      return;
    }

    if( this.reportTypeSelected === "0"){
      this.notifier.notify('error', "Please select report type");
      return;
    }

    if( this.reportTypeSelected === "graph" && this.reportGraphTypeSelected === "0"){
      this.notifier.notify('error', "Please select graph type");
      return;
    }

    if (this.selectedColumnObjArray.length === 0) {
      this.notifier.notify('error', "Please add coulumn for template");
      return;
    }
    const data = {
      client_id: this.clientId,
      template: this.templateName,
      columns: this.selectedColumnObjArray,
      createdBy: this.messageService.getUserId(),
      table: this.reportTableName,
      type: this.reportTypeSelected,
      graph: this.reportGraphTypeSelected
    };

    console.log(data);
    this.dataLoaded = false;
    this._rest.addReportConfiguratorTemplate(data).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        //this.isError = false;
        this.columnObjArray = this.respObject.details;
        this.dataLoaded = true;
        this.notifier.notify('success', "Template Added Successfully");
        this.selectedReportTableId = 0;
        this.reportTypeSelected = '0';
        //this.onPageLoad();
      } else {
        this.isError = true;
        this.dataLoaded = true;
        this.notifier.notify('error', this.respObject.errorMessage);
        
      }
    }, (err) => {
      this.isError = true;
      this.dataLoaded = true;
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
      //return;
    });
  }

  close() {
    this.dialogRef.close();
  }

}
